import { gql } from "@outschool/ui-apollo";

export const meetingReviewMutation = gql`
  mutation MeetingReviewMutation($sectionUid: ID!, $rating: Int!) {
    createMeetingReview(sectionUid: $sectionUid, rating: $rating) {
      uid
      learnerUid
      rating
      meetingUid
      sectionUid
    }
  }
`;
